/* モフトレチェック */
import * as React from 'react';
import KanaList from '../containers/KanaList';
import { kirokuUserListHeader, UserSelectBody, Type } from './UserListField';

import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';

interface UserSelectMoffCheckProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
  moffCheckCount?: any;
  moffCheckActions: any;
}

class UserSelectMoffCheck extends React.Component<UserSelectMoffCheckProps, {}> {
  static propTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired,
    // モフトレチェック.
    moffCheckCount: PropTypes.any.isRequired,
    moffCheckActions: PropTypes.any.isRequired,
  };

  componentWillMount() {
    document.title = 'モフトレチェック';

    this.props.headerActions.setPage(Header.USER_SELECT_MOFF_CHECK);

    // Action
    this.props.moffAPIActions.getUsers();
  }

  render () {
    return (
      <div>
        <KanaList />
        { // 
          (() => {
            if (this.props.moffAPI.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }

        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {kirokuUserListHeader}
              </tr>
            </thead>
            <tbody>
            {(this.props.moffAPI.Loaded) ? 
              // ロードしたUserを表示.
              <UserSelectBody
                type={Type.MoffCheck}
                users={this.props.moffAPI.result}
                moffCheckCount={this.props.moffCheckCount}
                moffCheckActions={this.props.moffCheckActions}
              /> 
             :
              // ロード中.
              (null)
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UserSelectMoffCheck;



// WEBPACK FOOTER //
// ./src/components/UserSelectMoffCheck.tsx